import React from 'react'
import { Provider } from "react-redux"
import AppRoutes from '@apps/AppRoutes'
import { MountsProvider } from '@engine/contexts/MountsContext'
import Theme from '@engine/components/Theme'
import ApplicationProvider from '@apps/contexts/ApplicationContext'
import { BaseProvider, koodoTheme } from '@telus/koodo-ui-kit'
// Palette CSS is pulled in transitively via @telus/koodo-ui-kit; not a direct dep.
// eslint-disable-next-line import/no-extraneous-dependencies
import '@telus-uds/palette-koodo/build/web/fonts/fonts-local.css'
import '@brands/index.css'
import store from "@apps/redux/store"

export default function App() {
  return (
    <BaseProvider defaultTheme={koodoTheme}>
      <Theme>
        <MountsProvider>
          <ApplicationProvider>
            <Provider store={store}>
              <AppRoutes />
            </Provider>
          </ApplicationProvider>
        </MountsProvider>
      </Theme>
    </BaseProvider>
  )
}
